export default "__VITE_ASSET__BKuHqxtZ__"